export default "__VITE_ASSET__C$f6Ksje__"